import basic from  './basic'
import service from  './service'
// import module from  './module'

const zh = {
    ...basic,
    ...service,
    // ...module,
}

export default zh
